import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import TextArea from "components/General/Form/TextArea";
import Input from "components/General/Form/Input";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import "containers/ProjectCommon.css";
import "containers/Projects/ActiveProject/Step_3/VolunteerTime/VolunteerTime.css";
import AxiosConfig from "axiosConfig";
import ProgressStepper from "components/Project/ProgressStepper";
import ProjectBanner from "components/Project/ProjectBanner";
import Address from "components/General/Form/Address/Address";
import Video from "components/General/Video/Video";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";

/**
 * @summary: Creates the UI of the fundraiser page
 * @description: Creates the fields and styling for the challenge 3 fundraise page
 * @class: FundraiserDetails
 * @extends: React.component
 * @see: {VolunteerTime.css}
 * @param: projectName, projectBanner, projectBadge, projectJoinDate, projectChallengeStatus
 * @returns: {FundraiserDetails}
 */

class FundraiserDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.projectSlug,
      challengeSlug: this.props.challengeSlug,
      projectName: "",
      projectBanner: "",
      projectBadge: "",
      projectJoinDate: "",
      projectChallengeStatus: "",
    };
  }
  componentDidMount() {
    AxiosConfig.get(`/impactprojects/project/${this.state.projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data.name,
          projectBanner: res.data.banner,
          projectBadge: res.data.badge,
          projectJoinDate: res.data.project_join_date,
          projectChallengeStatus: res.data.challenge_status,
        });
      })
      .catch();
  }

  render() {
    return (
      <div className="header_main">
        <form onSubmit={this.handleFormSubmit}>
          <div className="page_main">
            <div className="content_project_info_vertical">
              <ProjectOldInfo
                vertical={true}
                project={this.state.projectSlug}
              />
            </div>
            <div className="page_details_main content_section">
              <div className="project-banner">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
              <div className="page_info_hr_content_main">
                <ProjectOldInfo
                  project={this.props.projectSlug}
                  showChallengeDetails={true}
                />
              </div>
              <div className="page_details_content_main border-0">
                <div className="stepper_main_content">
                  <ProgressStepper
                    currentStep="4"
                    challengeSlug={this.props.challengeSlug}
                    goalDate={this.props.goalDate}
                    adventureId={this.props.adventureId}
                    projectSlug={this.props.projectSlug}
                    adventureSlug={this.props.adventureSlug}
                    isInvite={this.props.isInvite}
                    email={this.props.email}
                    invitationId={this.props.invitationId}
                    projectUserId={this.props.projectUserId}
                    showStepper={this.props.showStepper}
                  />
                </div>
              </div>
              <div className="page_details_content_main">
                <div className="project-details">
                  <div className="insideContent">
                    {this.props.isInvite ? (
                      <h3 className="textHeader">STEP 2 : MAKE AN IMPACT</h3>
                    ) : (
                      <h3 className="textHeader">STEP 5 : MAKE AN IMPACT</h3>
                    )}
                  </div>
                </div>
                <TextTheme
                  message="FUNDRAISE"
                  className="mt-15 text_medium aboutMeTitle text_semi_bold d-inline-block mb-15"
                />
                <TextTheme
                  message="Fundraise money for a local organization that supports the mission of the project."
                  className="text_medium text_black"
                />
                <div className="project-form-inner">
                  <Address
                    changeHandler={this.props.changeHandler}
                    hasName={this.props.hasName}
                    hasAddress={this.props.hasAddress}
                    hasCity={this.props.hasCity}
                    hasStateName={this.props.hasStateName}
                    name={this.props.name}
                    address={this.props.address}
                    city={this.props.city}
                    stateName={this.props.stateName}
                    website={this.props.website}
                  />
                  <TextTheme
                    message="2. How much money did you raise in your fundraiser?"
                    className="mt-30 text_small text_black"
                  />
                  <div className="mt-15 form_control">
                    <Input
                      inputType="number"
                      name="dollars"
                      value={this.props.dollars}
                      placeholder="0"
                      handleChange={this.props.handleNumbers.bind(this)}
                    />
                    <label>
                      <TextTheme
                        message="Dollars"
                        className="text_small text_black"
                      />
                    </label>
                  </div>
                  {!this.props.hasDollars ? (
                    <TextTheme
                      message="Please enter the amount greater than 0 dollars"
                      className="mt-1 text_small text_red"
                    />
                  ) : null}
                  <TextTheme
                    message="3. Describe what you did in your fundraiser."
                    className="mt-30 text_small text_black"
                  />
                  <TextArea
                    name="description"
                    rows={3}
                    cols={80}
                    value={this.props.defaultIfEmpty(this.props.description)}
                    handleChange={this.props.changeHandler.bind(this)}
                  />
                  {!this.props.hasDescription ? (
                    <TextTheme
                      message="Please share the description of your activity"
                      className="mt-1 text_small text_red"
                    />
                  ) : null}
                  <TextTheme
                    message="4. Share a video or photo that celebrates your fundraising experience."
                    className="mt-30 text_small text_black"
                  />
                </div>
                <div className="d-inline-block w-100 mb-15">
                  <Video
                    src={this.props.video}
                    id="file"
                    style={{ display: "none" }}
                    type="file"
                    name="video"
                    accept="video/*"
                    onChange={this.props.videoHandler.bind(this)}
                    count={this.props.count}
                    fileType={this.props.fileType}
                    fileData={this.props.fileData}
                    displayCustomPopup={this.props.displayCustomPopup}
                    displayImagePopup={this.props.displayImagePopup}
                    displayCreationSuite={this.props.displayCreationSuite}
                    closePopUp={this.props.closePopUp}
                    openPopUp={this.props.openPopUp}
                    imagePopup={this.props.imagePopup}
                    popupControl={this.props.popupControl}
                    fileUpload={this.props.fileUpload}
                    uploadApi={this.props.uploadApi}
                    openCreationSuite={this.props.openCreationSuite}
                    closeCreationSuite={this.props.closeCreationSuite}
                    handleCreationSuiteUpload={this.props.handleCreationSuiteUpload}
                  />
                </div>
                {!this.props.hasVideo ? (
                  <TextTheme
                    message="Please upload a video or photo sharing your experiences. Maximum 2MB accepted for GIFs."
                    className="mt-1 text_small text_red mb-15"
                  />
                ) : null}
                <TwoButtonLayout
                  button1Text="SAVE"
                  button2Text="COMPLETE PROJECT"
                  button1Click={(event) => this.props.onSubmit(event, "save")}
                  button2Click={(event) => this.props.onSubmit(event, "done")}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default FundraiserDetails;
